import { render, staticRenderFns } from "./ExchangeSettings.vue?vue&type=template&id=aca99f0c&"
import script from "./ExchangeSettings.vue?vue&type=script&lang=js&"
export * from "./ExchangeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports